import URL from 'utils/URL';

export const IS_DEV = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development';

export const IS_STAGING = window.location.host.includes('-staging');

export const IS_UAT = window.location.host.includes('www-tbus.uat.');

export const urlQuery = URL.current().query;
